var React = require('react');

function LockInline (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t\t.st0 {\n\t\t\tfill: currentColor;\n\t\t}\n\t"),React.createElement("g",{"key":1},React.createElement("path",{"className":"st0","d":"M7.9,10.1c0-3.5,2.8-6.4,6.4-6.4c3.5,0,6.4,2.8,6.4,6.4v3.4c0,0.4-0.3,0.7-0.7,0.7H8.6c-0.4,0-0.7-0.3-0.7-0.7\n\t\tV10.1z M11.2,23.2c0-1.5,1-2.7,2.5-3c1.4-0.3,2.8,0.6,3.3,1.9c0.5,1.4-0.1,2.9-1.3,3.6v3.4c0,0.8-0.7,1.5-1.5,1.5\n\t\tc-0.8,0-1.5-0.7-1.5-1.5v-3.4C11.8,25.2,11.2,24.2,11.2,23.2z M25.4,14.2h-1.1v-4.1C24.3,4.5,19.8,0,14.2,0S4.1,4.5,4.1,10.1v4.1H3\n\t\tc-1.7,0-3,1.3-3,3v15.7c0,1.7,1.3,3,3,3h22.4c1.7,0,3-1.3,3-3V17.2C28.4,15.5,27.1,14.2,25.4,14.2z"}))]);
}

LockInline.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 28.4 35.9","style":{"enableBackground":"new 0 0 28.4 35.9"},"xmlSpace":"preserve"};

module.exports = LockInline;

LockInline.default = LockInline;
